// Entry point for the build script in your package.json

import Rails from '@rails/ujs'
import './src/components.js'
import startup from './src/startup.js'

// Import specific Bootstrap components
import 'bootstrap/js/dist/collapse' // for menu
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tooltip'

// Start Rails UJS and application
Rails.start()
startup()
